import { render, staticRenderFns } from "./ReportFixedLegend.vue?vue&type=template&id=46637ac2&scoped=true"
import script from "./ReportFixedLegend.vue?vue&type=script&lang=js"
export * from "./ReportFixedLegend.vue?vue&type=script&lang=js"
import style0 from "./ReportFixedLegend.vue?vue&type=style&index=0&id=46637ac2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46637ac2",
  null
  
)

export default component.exports